import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import Flag from '../../../redux/flags/Flag';
import ScrollableContent from '../../../ScrollableContent';
import Dropdown from '../../../Dropdown';
import DropdownMenu from '../../../Menu';
import CheckIcon from '../../../Icons/Check';
import { IconSize } from '../../../Icons/IconWrap';
import { isNullableDropdownGroup, convertNullableGroupToDropdownGroup, } from '../../types';
import BiLink from '../../../biLogger/Components/BiLink';
import BiSpan from '../../../biLogger/Components/BiSpan';
import StandardMenuSubmenu from './StandardMenuSubmenu';
import s from './StandardMenu.scss';
var StandardMenu = /** @class */ (function (_super) {
    tslib_1.__extends(StandardMenu, _super);
    function StandardMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLabelSticky: false,
        };
        _this.renderItem = function (item, idx, hideCheckIcon) {
            var icon;
            if (item.icon) {
                icon = React.cloneElement(item.icon, {
                    className: classnames(s['menu-item-icon'], item.iconClassName),
                });
            }
            var _a = _this.getComponentClassAndProps(item), componentClass = _a.componentClass, componentProps = _a.componentProps;
            var key = item.value || "item_" + idx;
            return (React.createElement(Dropdown.MenuItem, { key: key, componentClass: componentClass, componentProps: componentProps, className: classnames(s['menu-item'], item.onClick && s['clickable'], item.disabled && s['disabled'], item.danger && s['danger'], _this.props.itemClassName, item.className), value: item.value, disabled: item.disabled, selected: item.selected, label: typeof item.label === 'string' ? item.label : undefined, onClick: item.onClick, biData: item.biData },
                icon,
                _this.renderItemLabel(item),
                item.selected && !hideCheckIcon && (React.createElement(CheckIcon, { className: s['selected-icon'], size: IconSize.TINY }))));
        };
        _this.onScrolled = function (scrollTop) {
            _this.setState({ isLabelSticky: scrollTop !== 0 });
        };
        return _this;
    }
    StandardMenu.prototype.render = function () {
        var _this = this;
        var label = this.props.label;
        var scrollable = this.props.scrollable || label;
        var content = this.renderMenu();
        if (scrollable) {
            content = (React.createElement(ScrollableContent, { className: s['scrollable-content'], onScrolled: this.onScrolled }, content));
        }
        // Due to Dropdown's approach of traversing children, using the withFeatureFlags HOC
        // on this component would f*ck up every dropdown, while hooks would require a big refactor.
        // With that in mind, this seems to be the least intrusive way of featuring protecting these changes.
        // On test environment we avoid using the Flag component because it'd affect snapshot tests.
        if (process.env.NODE_ENV === 'test') {
            return this.renderContent(content);
        }
        return (React.createElement(Flag, { condition: "tooltips_ui_updates", render: function () { return _this.renderContent(content, true); }, fallbackRender: function () { return _this.renderContent(content); } }));
    };
    StandardMenu.prototype.renderContent = function (content, isUpdatedVersion) {
        if (isUpdatedVersion === void 0) { isUpdatedVersion = false; }
        var _a = this.props, label = _a.label, withCardWrapper = _a.withCardWrapper, withHoverEffect = _a.withHoverEffect, withPaddings = _a.withPaddings, withItemHorizontalPaddings = _a.withItemHorizontalPaddings, className = _a.className, labelClassName = _a.labelClassName;
        var isLabelSticky = this.state.isLabelSticky;
        var hasPaddings = isUpdatedVersion
            ? withPaddings && !label
            : withPaddings;
        return (React.createElement("div", { className: classnames(s['root'], withHoverEffect && s['with-hover-effect'], withCardWrapper && s['with-card-wrapper'], hasPaddings && s['with-paddings'], !withItemHorizontalPaddings && s['without-item-horizontal-paddings'], // negative condition, so that the default selector is weaker and allows custom overrides
            isUpdatedVersion && s['v2'], className) }, label ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classnames(s['label'], isLabelSticky && s['sticky'], labelClassName) }, label),
            content)) : (content)));
    };
    StandardMenu.prototype.renderMenu = function () {
        var _this = this;
        var _a = this.props, items = _a.items, menuClassName = _a.menuClassName, onClose = _a.onClose, onSelect = _a.onSelect, lightText = _a.lightText, _b = _a.hideCheckIcon, hideCheckIcon = _b === void 0 ? false : _b;
        return (React.createElement(Dropdown.Menu, { className: classnames(s['menu'], lightText && s['light-text'], menuClassName), onClose: onClose, onSelect: onSelect }, items.map(function (item, idx) {
            if (!item) {
                return null;
            }
            if (isNullableDropdownGroup(item)) {
                var group = convertNullableGroupToDropdownGroup(item);
                if (group) {
                    return _this.renderGroup(group, idx, hideCheckIcon);
                }
                return null;
            }
            return _this.renderItem(item, idx, hideCheckIcon);
        })));
    };
    StandardMenu.prototype.getComponentClassAndProps = function (item) {
        var componentClass = item.componentClass ? item.componentClass : BiSpan;
        var componentProps = item.componentProps || {};
        if (item.link) {
            return {
                componentClass: item.componentClass || BiLink,
                componentProps: tslib_1.__assign({}, componentProps, { href: item.link, target: item.target, title: item.title }),
            };
        }
        if (item.submenu) {
            return {
                componentClass: StandardMenuSubmenu,
                componentProps: tslib_1.__assign({}, componentProps, { submenu: item.submenu }),
            };
        }
        return {
            componentClass: componentClass,
            componentProps: componentProps,
        };
    };
    StandardMenu.prototype.renderItemLabel = function (item) {
        // allows some items to separate visually their text label from option label
        if (item.complexLabel) {
            return item.complexLabel;
        }
        return typeof item.label === 'string' ? (React.createElement("span", { className: s['menu-item-text-label'] }, item.label)) : (item.label);
    };
    StandardMenu.prototype.renderGroup = function (group, idx, hideCheckIcon) {
        var _this = this;
        return (React.createElement(Dropdown.ItemGroup, { className: classnames(s['menu-group'], group.className, this.props.groupClassName), key: group.label || "group_" + idx, label: group.label, disabled: group.disabled }, group.items.map(function (item, sub_idx) {
            return _this.renderItem(item, sub_idx, hideCheckIcon);
        })));
    };
    StandardMenu.displayName = 'StandardMenu';
    StandardMenu.defaultProps = {
        componentType: DropdownMenu,
        withHoverEffect: true,
        withCardWrapper: true,
        withPaddings: true,
        withItemHorizontalPaddings: true,
    };
    return StandardMenu;
}(React.PureComponent));
export { StandardMenu };
export default StandardMenu;
//# sourceMappingURL=StandardMenu.js.map